import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { TextField } from '@mui/material';
import { countryListWithCode } from 'src/const';

export default function AutocompleteSearchbarforCountryWithCode({
  onCountryChange,
  defaultCountryToUnlock,
}) {
  const [selectedCountry, setSelectedCountry] = React.useState(defaultCountryToUnlock);

  React.useEffect(() => {
    handleOnChange(null, defaultCountryToUnlock);
  }, []);

  const handleOnChange = (event, value) => {
    if (value !== null && value !== undefined) {
      setSelectedCountry(value);
      onCountryChange(value.code);
    }
  };

  return (
    <Autocomplete
      id="country-select-demo"
      placeholder="Choose a country"
      sx={{ width: '80%', marginTop:"10px", 
      "& .MuiOutlinedInput-root": {
        borderRadius: 200,
        height:50
      }
    }}
      options={countryListWithCode}
      autoHighlight
      getOptionLabel={option => option.label}
      renderOption={(props, option) => (
        <li {...props}>
          <ListItem>
            <ListItemIcon>
              <img
                loading="lazy"
                width="20"
                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                alt=""
              />
            </ListItemIcon>
            <ListItemText>
              {option.label + ' '}
              <Typography variant="body2" component="span">
                ({option.code})
              </Typography>
            </ListItemText>
          </ListItem>
        </li>
      )}
      renderInput={params => (
        <TextField {...params} label="Choose a country" placeholder="Choose a country" />
      )}
      onChange={handleOnChange}
      value={selectedCountry}      
    />
  );
}
